import { render, staticRenderFns } from "./statusvideo.vue?vue&type=template&id=5d5ef254&scoped=true&"
import script from "./statusvideo.vue?vue&type=script&lang=js&"
export * from "./statusvideo.vue?vue&type=script&lang=js&"
import style0 from "./statusvideo.vue?vue&type=style&index=0&id=5d5ef254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ef254",
  null
  
)

export default component.exports